import { ExtendedNextLink } from 'components/Basic/ExtendedNextLink/ExtendedNextLink';
import Image from 'components/Basic/Image/Image';
import { SubCategoryType } from 'components/Blocks/Categories/CategorySubcategories/CategorySubcategories';
import { twJoin } from 'tailwind-merge';
import { FilterOptionsUrlQueryType } from 'types/productFilter';

type ListItemProps = {
    listedItem: SubCategoryType;
    isSubcategory?: boolean;
    filter?: FilterOptionsUrlQueryType;
    displayProductCount?: boolean;
    className?: string;
};

export const categoryLinkTwClass = (): string =>
    twJoin(
        'flex h-full w-full cursor-pointer flex-row items-center justify-start rounded-md bg-grayLight py-3 px-2 text-body leading-4 text-primary no-underline ease-defaultTransition duration-200',
        'lg:py-3 lg:px-2 lg:text-h6 lg:leading-5',
        'hover:bg-white hover:no-underline hover:shadow-grayDown',
    );

const categoryItemTwClass = 'mb-2 w-full px-1 sm:w-1/2 md:mb-3 md:w-1/3 md:px-1 xl:w-1/5';

const CategoryItem: FC<ListItemProps> = ({ listedItem, isSubcategory, filter, displayProductCount, className }) => {
    return (
        <li className={twJoin(categoryItemTwClass, isSubcategory && 'xl:w-1/4')}>
            <ExtendedNextLink
                type={listedItem.link ? 'static-presumed-category' : 'category'}
                href={listedItem.link || listedItem.slug}
                queryParams={filter ? { filter: JSON.stringify(filter) } : undefined}
                className={twJoin(categoryLinkTwClass(), className)}
            >
                <>
                    {'image' in listedItem && (
                        <div
                            className={twJoin(
                                'relative mr-2 flex h-8 w-14 flex-shrink-0 items-center justify-start lg:h-14 lg:w-[90px]',
                                '[&>img]:max-h-full [&>img]:max-w-full [&>img]:mix-blend-multiply',
                            )}
                        >
                            {listedItem.image ? (
                                <Image
                                    key={listedItem.slug}
                                    src={listedItem.image}
                                    alt={listedItem.name}
                                    width={90}
                                    height={56}
                                />
                            ) : (
                                <Image src="/images/noimage-arrow.png" alt={listedItem.name} width={90} height={56} />
                            )}
                        </div>
                    )}
                    <div className="leading-4 lg:leading-5">
                        {`${listedItem.name} `}
                        {displayProductCount !== false && !listedItem.link && (
                            <span className="inline-block text-tiny leading-4 text-grayDarker lg:text-small lg:leading-5">
                                ({listedItem.productsCount})
                            </span>
                        )}
                    </div>
                </>
            </ExtendedNextLink>
        </li>
    );
};

export default CategoryItem;
